import { useState } from "react";
import * as XLSX from "xlsx";
import { MathJax, MathJaxContext } from "better-react-mathjax";
import isDesktop from "../isDesktop";
import Sidebar from "../sidenav/Sidenav";
import { Link } from "react-router-dom";
import { ReactComponent as UserIcon } from "../assets/icons/UserIcon.svg";
import { ReactComponent as Hemberger } from "../assets/icons/Hemberger.svg";
import { hasStoredTabAccess } from '../utils/access';

const ReviewQuestions = () => {
  const isDesktopDevice = isDesktop();
  const isAuthorized = hasStoredTabAccess('Review Questions');
  const [tableData, setTableData] = useState([]);
  const [headers, setHeaders] = useState([]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  
    const closeSidebar = () => {
      setIsSidebarOpen(false);
    };
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    const fileExtension = file.name.split(".").pop().toLowerCase();

    reader.onload = (event) => {
      let workbook;
      if (fileExtension === "csv") {
        workbook = XLSX.read(event.target.result, { type: "binary", raw: true });
      } else {
        workbook = XLSX.read(event.target.result, { type: "array", cellText: false, cellDates: true });
      }

      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(worksheet, { raw: false, defval: "" });
      console.log(data)
      if (data.length > 0) {
        setHeaders(Object.keys(data[0]));
        setTableData(data);
      }
    };

    if (fileExtension === "csv") {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  };

  // Helper function to render cell with MathJax for backtick expressions only
  const renderCellContent = (text) => {
    if (!text) return "";
    // Replace only text inside backticks with $...$
    const withMath = text.replace(/`([^`]*)`/g, (_, expr) => `$${expr}$`);
    return withMath;
  };
    const config = {
    loader: { load: ["input/asciimath"] },
    options: {
      menuOptions: {
        settings: {
          inTabOrder: false,
        },
      },
    },
  };
  if (!isAuthorized) {
    return (
      <div className="container-fluid mt-5">
        <h2 style={{ marginTop: "5%" }}>
          You are unauthorized to access this page
        </h2>
      </div>
    );
  }
  return (
    <>
    {!isDesktopDevice &&
    <div>
        <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  margin: "0.5rem 0.75rem 1.25rem 0.75rem",
                }}
              >
                <div
                  onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: "36px",
                    height: "36px",
                    borderRadius: "18px",
                    background: "#EAF1F7",
                  }}
                >
                  <Hemberger />
                </div>
                <Link to="/profile">
                  <UserIcon />
                </Link>
              </div>
              <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
    </div>
    }
    <div className="container-fluid" style={{ marginTop: "6vw" }}>
      <h1>Choose a CSV file to view</h1>
      <MathJaxContext version={3} config={config}>
      <div className="p-6">
        <h1 className="text-2xl font-bold mb-4">Review Questions</h1>

        <input
          type="file"
          accept=".csv,.xlsx,.xls"
          onChange={handleFileUpload}
          className="mb-4"
        />

        {tableData.length > 0 ? (
          <table className="border-collapse border border-gray-300 text-sm">
            <thead>
              <tr className="bg-gray-100">
                {headers.map((header) => (
                  <th key={header} className="border border-gray-300">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  {headers.map((header) => (
                    <td key={header} className="border border-gray-300">
                      <MathJax dynamic>
                        {row[header]}
                      </MathJax>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-gray-600">Upload a CSV or Excel file to see its content.</p>
        )}
      </div>
    </MathJaxContext>
    </div>
    </>
  );
};

export default ReviewQuestions;
